import { render } from "./AnalisiDashboard.vue?vue&type=template&id=ba8be3a2&scoped=true"
import script from "./AnalisiDashboard.vue?vue&type=script&lang=js"
export * from "./AnalisiDashboard.vue?vue&type=script&lang=js"

import "./AnalisiDashboard.vue?vue&type=style&index=0&id=ba8be3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8be3a2"]])

export default __exports__